/**
 * 桥接可移植包 `@zhxt/icon-library`（CJS）→ ESM named exports
 */
import iconLibrary from '@zhxt/icon-library';

export const TEARDROP_PATH = iconLibrary.TEARDROP_PATH;
export const CHROME_TEARDROP_PATH = iconLibrary.CHROME_TEARDROP_PATH;
export const GEM_CX = iconLibrary.GEM_CX;
export const GEM_CY = iconLibrary.GEM_CY;
export const GEM_R = iconLibrary.GEM_R;
export const ICON_STYLES = iconLibrary.ICON_STYLES;
export const WATER_DROP_STATES = iconLibrary.WATER_DROP_STATES;
export const CHROME_EXTRA_CATALOG = iconLibrary.CHROME_EXTRA_CATALOG;
export const MEMBER_ICON_GLYPHS = iconLibrary.MEMBER_ICON_GLYPHS;
export const MEMBER_ICON_CATALOG = iconLibrary.MEMBER_ICON_CATALOG;
export const SPEED_ICON_BANDS = iconLibrary.SPEED_ICON_BANDS;
export const TEARDROP_PUBLIC_DIR = iconLibrary.TEARDROP_PUBLIC_DIR;
export const CHROME_PUBLIC_DIR = iconLibrary.CHROME_PUBLIC_DIR;

export const isValidMemberIconKey = iconLibrary.isValidMemberIconKey.bind(iconLibrary);
export const parseMemberIconRef = iconLibrary.parseMemberIconRef.bind(iconLibrary);
export const resolveSpeedIconKey = iconLibrary.resolveSpeedIconKey.bind(iconLibrary);
export const getMemberIconPublicUrl = iconLibrary.getMemberIconPublicUrl.bind(iconLibrary);
export const toPublicUploadIconUrl = iconLibrary.toPublicUploadIconUrl.bind(iconLibrary);
export const buildTeardropSvgMarkup = iconLibrary.buildTeardropSvgMarkup.bind(iconLibrary);
export const resolveMemberIconKey = iconLibrary.resolveMemberIconKey.bind(iconLibrary);
export const chromeStatusForMarkerState = iconLibrary.chromeStatusForMarkerState.bind(iconLibrary);
export const toChromeIconKey = iconLibrary.toChromeIconKey.bind(iconLibrary);

export const ICON_GLYPHS = iconLibrary.ICON_GLYPHS;
export const ICON_CATALOG = iconLibrary.ICON_CATALOG;
export const isValidIconKey = iconLibrary.isValidIconKey.bind(iconLibrary);
export const getIconPublicUrl = iconLibrary.getIconPublicUrl.bind(iconLibrary);
export const buildTeardropSvg = iconLibrary.buildTeardropSvg.bind(iconLibrary);
export const resolveIconKeyForMember = iconLibrary.resolveIconKeyForMember.bind(iconLibrary);
export const listIcons = iconLibrary.listIcons.bind(iconLibrary);
export const listIconStyles = iconLibrary.listIconStyles.bind(iconLibrary);
export const listSpeedBands = iconLibrary.listSpeedBands.bind(iconLibrary);
export const wrapScaledGlyph = iconLibrary.wrapScaledGlyph.bind(iconLibrary);
export const GLYPH_SCALE = iconLibrary.GLYPH_SCALE;

export default iconLibrary;
